"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToPascalCase = void 0;
var convertToPascalCase = function convertToPascalCase(name) {
  return "".concat(name).replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w+)/, "g"), function ($1, $2, $3) {
    return "".concat($2.toUpperCase() + $3.toLowerCase());
  }).replace(new RegExp(/\s/, "g"), "").replace(new RegExp(/\w/), function (s) {
    return s.toUpperCase();
  });
};
exports.convertToPascalCase = convertToPascalCase;